import { Alert, AnimatedContainer, Button, ContentContainer, FlexRow } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ErrorBoundaryFormModal from './ErrorBoundaryFormModal';

interface FallbackProps {
  eventId: string;
  resetError: () => void;
}

interface OwnProps {
  fallbackProps: FallbackProps;
}

const ErrorBoundaryContent = (props: OwnProps) => {
  const { fallbackProps } = props;

  const { tError } = useCustomTranslation();

  const navigate = useNavigate();

  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <AnimatedContainer>
        <ContentContainer>
          <Alert
            message={tError('error_boundary_title')}
            description={tError('error_boundary_description')}
            type="error"
            action={
              <FlexRow noMargin>
                <Button
                  onClick={() => {
                    navigate('/');
                    fallbackProps.resetError();
                  }}
                >
                  {tError('error_boundary_go_home')}
                </Button>
                <Button type="primary" onClick={() => setShowForm(true)} className="ml-1">
                  {tError('error_boundary_fill_form')}
                </Button>
              </FlexRow>
            }
          />
        </ContentContainer>
      </AnimatedContainer>
      <ErrorBoundaryFormModal
        eventId={fallbackProps.eventId}
        resetError={fallbackProps.resetError}
        open={showForm}
      />
    </>
  );
};

export default ErrorBoundaryContent;
